import { useState } from "react";
import { useSelector } from "react-redux";

import * as Api from "@/api";
import Avatar from "@/design/components/Avatar";
import Valkyrie, { viSpinnerThird } from "@sippy-platform/valkyrie";

import { ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function AddAccountItem({ account }) {
  const [pending, setPending] = useState(false);

  const pbx = useSelector((state) => state.domain.pbx);

  const addAccountToPbx = (account) => {
    setPending(true);
    Promise.resolve(Api.postAccountToPbx(account, pbx))
      .then(() => Promise.resolve(Api.getAccounts()))
      .finally(() => setPending(false));
  };

  return (
    <ListItem disablePadding>
      <ListItemButton onClick={() => addAccountToPbx(account)} disabled={pending}>
        <ListItemAvatar>
          <Avatar text={`${account.firstname} ${account.lastname ?? ""}`} />
        </ListItemAvatar>
        <ListItemText primary={`${account.firstname} ${account.lastname ?? ""}`} secondary={account.email} />
        {pending && (
          <ListItemIcon sx={{ minWidth: 16 }}>
            <Valkyrie icon={viSpinnerThird} spin />
          </ListItemIcon>
        )}
      </ListItemButton>
    </ListItem>
  );
}

AddAccountItem.propTypes = {
  account: PropTypes.object,
};

export default AddAccountItem;
